import React, { Component } from 'react';
// components
import Table from '../Items/Table';
import { Button } from '@material-ui/core';

class DepartmentsTable extends Component {

    state = {
        menuStatus: false,
        anchorEl: null,
    }

    render() {
        const tableData = {
            title: "Departman Listesi",
            options: {
                paging: true,
                selection: true,
                grouping: true,
                filtering: true,
                columnsButton: true,
                exportButton: false,
                actionsColumnIndex: 4,
                pageSize: 10,
                pageSizeOptions: [10, 20, 50, 100, 1000]
            },
            columns: [
                this.props.person.permissions.department.update ? {
                    title: 'İşlem',
                    render: rowData => {
                        return (
                            <Button onClick={() => this.props.editForm(rowData)}>Güncelle</Button>
                        )
                    },
                } : {},
                { title: "Departman Adı", field: "name" },
                { title: "İş Tipi", field: "taskType.name" },
            ],
            data: this.props.departments
        };

        let tableActions = [];
        if (this.props.person.permissions.department.create) {
            tableActions.push({
                icon: 'plus_one',
                isFreeAction: true,
                tooltip: 'Yeni Kayıt Ekle',
                onClick: this.props.addForm,
                iconProps: {
                    style: {
                        fontSize: 40,
                        color: 'green'
                    }
                }
            })
        }
        if (this.props.person.permissions.department.delete) {
            tableActions.push({
                icon: 'delete',
                tooltip: 'Sil',
                onClick: this.props.delete,
                iconProps: {
                    style: {
                        fontSize: 40,
                        color: 'red'
                    }
                }
            })
        }

        return (
            <div>
                <Table
                    tableData={tableData}
                    actions={tableActions.length > 0 ? tableActions : null} />
            </div>
        )
    }
}


export default DepartmentsTable;